import { ArrowLeftIcon } from "lucide-react";
import Link from "next/link";
import BaseLayout from "@/components/base-layout";
import { Header } from "@/components/header";

export default function Custom404() {
  return (
    <BaseLayout>
      <Header
        canonical="https://promptwatch.com/404"
        title="404 - Page Not Found | Promptwatch.com"
        description="The page you are looking for doesn't exist or has been moved."
      />
      <main className="overflow-hidden duration-150 min-h-screen flex items-center">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-200/50 via-blue-100/50" />
        <div
          aria-hidden="true"
          className="absolute h-full w-full scale-[0.8] bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#fff_70%,transparent_100%)]"
        />
        <section className="relative w-full">
          <div className="relative mx-auto max-w-6xl px-4 py-16 sm:px-12">
            <div className="flex flex-col items-center justify-center text-center">
              <h1 className="text-title text-6xl font-bold mb-4">404</h1>
              <h2 className="text-2xl font-semibold mb-6">Page Not Found</h2>
              <p className="text-lg text-muted-foreground mb-8 max-w-sm">The page you are looking for doesn't exist or has been moved.</p>
              <Link
                href="/"
                className="px-6 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors flex items-center gap-2"
              >
                <ArrowLeftIcon className="size-4" /> Return to Home
              </Link>
            </div>
          </div>
        </section>
      </main>
    </BaseLayout>
  );
}
